/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
  ErrorMessage,
  Field,
  Form, Formik,
} from 'formik';
import React from 'react';
import { HiArrowUpRight } from 'react-icons/hi2';
import * as Yup from 'yup';
import swMini from '../../assets/icons/swmini.svg';
import { footerLinks, socialLinks } from '../../utils/constants';
// import swMini from '../../assets/icons/minilogoFive.svg';
import { Spinner } from '../../components';
import { useNewsLetter } from '../../services';

function Footer() {
  const { isLoading, submitContactInfo } = useNewsLetter();

  const handleSubmit = (val) => {
    // console.log('hello', val);

    submitContactInfo(val);
  };

  return (
    <div className=" p-4 lg:px-[6.2rem] lg:py-[2rem] grid grid-cols-1 lg:grid-cols-[2fr_1fr_1fr_1fr] bg-[#F7F7F7] justify-between  lg:justify-items-center footer gap-6">
      <div className="flex flex-col justify-between lg:mr-8">
        <div className="flex flex-col gap-4">
          <img src={swMini} alt="logo" className="h-20 w-20" />
          <h2 className="text-lg font-normal">
            Get valuable strategy, culture, and
            brand insights straight to your inbox.
          </h2>

          {/* --form----- */}
          <Formik
            validationSchema={Yup.object({
              email: Yup.string().email('Invalid Email').required('Email required'),
            })}
            initialValues={{
              email: '',
            }}
            onSubmit={handleSubmit}
          >
            {
              () => (
                <Form>
                  <div className="flex">

                    <Field name="email" className="footer-input" placeholder="Email" />
                    <button type="submit" className="btn border-dark-500 border-b-2 ">{isLoading ? <Spinner className="text-dark-500" /> : <HiArrowUpRight className=" btn-icon" />}</button>
                  </div>

                  <ErrorMessage component="p" name="email" className="text-sm text-danger-500 mt-2" />
                </Form>
              )
            }
          </Formik>
        </div>

        {/* --social links----- */}
        <div className="flex items-center gap-2 font-bold mt-5 lg:mt-0">
          {
            socialLinks.map((el) => <a href={el.to} title={el.name} target="_blank" rel="noreferrer" key={el.title} className={`social-links ${el?.name}`}><img src={el.logo} alt={el.title} className="h-[36px] w-[36px]" /></a>)
          }
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <h1 className="text-lg font-normal">About</h1>
        {
          footerLinks.about.map((el) => <a href={el.to} target={el?.target === 'self' ? '_self' : '_blank'} key={el.title} rel="noreferrer" className="footer-link">{el.title}</a>)
        }
      </div>
      <div className="flex flex-col gap-3">
        <h1 className="text-lg font-normal">Expertise</h1>
        {
          footerLinks.services.map((el) => <a href={el.to} target={el?.target === 'self' ? '_self' : '_blank'} key={el.title} rel="noreferrer" className="footer-link">{el.title}</a>)
        }
      </div>
      <div className="flex justify-between flex-col gap-6">

        {/* --location-- */}
        <div className="flex flex-col gap-3">
          <h1 className="text-lg font-normal">Locations</h1>
          {
            footerLinks.locations.map((el) => (
              <div className="flex items-center gap-2 footer-link" key={el.title}>
                <img src={el.icon} alt="flag" />
                {el.title}
              </div>
            ))
          }
        </div>

        {/* --tal--- */}
        <div className="flex flex-col gap-3">
          <h1 className="text-lg font-normal">Talk To Us</h1>
          {
            footerLinks.talkToUs.map((el) => <a href={el.to} target={el?.target === 'self' ? '_self' : '_blank'} className="footer-link" key={el.title} rel="noreferrer">{el.title}</a>)
          }
        </div>
      </div>
    </div>
  );
}

export default Footer;
